import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Component from "./component";
import { fetchRtoQuestions, saveRtoQuestion } from "../rto-info/actions";

const mapStateToProps = ({
    rtoInfo: {
        questions,
        cmsImageGallery
    }
}) => ({
    questions,
    cmsImageGallery
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchRtoQuestionsConnect: fetchRtoQuestions,
    saveRtoQuestionConnect: saveRtoQuestion
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Component);
